import PortalIdParser from 'PortalIdParser';
import { memo, useMemo } from 'react';
//@ts-expect-error no types for ui-addon-iframeable
import ModalIFrame from 'ui-addon-iframeable/host/ModalIFrame';
import { jsx as _jsx } from "react/jsx-runtime";
const ProductsEditorIFrameModalComponent = props => {
  const {
    show,
    operation,
    onMessage
  } = props;
  const objectId = operation === 'EDIT' ? props.objectId : undefined;
  const pricingModelCategory = operation === 'CREATE' ? props.pricingModelCategory : undefined;
  const src = useMemo(() => {
    switch (operation) {
      case 'EDIT':
        return `/products/${PortalIdParser.get()}/embedded/edit/${objectId}`;
      case 'CREATE':
        {
          const baseUrl = `/products/${PortalIdParser.get()}/embedded/create`;
          return pricingModelCategory ? `${baseUrl}?pricing=${pricingModelCategory}` : baseUrl;
        }
      default:
        return null;
    }
  }, [objectId, operation, pricingModelCategory]);
  return show && src && /*#__PURE__*/_jsx(ModalIFrame, {
    appName: "products-ui",
    use: "fullscreen",
    width: "100%",
    height: "100%",
    iframePassthruProps: {
      'data-test-id': `products-editor-iframe-modal`,
      id: 'products-ui-iframe',
      title: 'Products Editor'
    },
    src: src,
    onMessage: onMessage
  });
};
export const ProductsEditorIFrameModal = /*#__PURE__*/memo(ProductsEditorIFrameModalComponent);